import React from "react";
import CommonModal from "PhishingManager/components/Modal";
import { ModalProps } from "PhishingManager/components/Modal/Modal.types";
import { useTranslation } from "react-i18next";

const ExitCampaignModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();

  return (
    <CommonModal
      visible={open}
      confirmText={t("phishingManager.exitCampaignModal.confirmText")}
      cancelText={t("phishingManager.exitCampaignModal.cancelText")}
      iconType={null}
      modalTitle={t("phishingManager.exitCampaignModal.title")}
      modalContentDesc={[
        t("phishingManager.exitCampaignModal.description.line1"),
        t("phishingManager.exitCampaignModal.description.line2")
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default ExitCampaignModal;